import { useFormContext } from "react-hook-form";
import * as yup from "yup"; // Add this import statement

export const combineSchemas = (schema: yup.ObjectSchema<any>[]) => yup.object().shape(schema.reduce((acc, curr) => Object.keys(curr.fields).reduce((acc, key) => ({ ...acc, [key]: acc[key] ? acc[key].concat(curr.fields[key]) : curr.fields[key] }), acc), {}));

export function getError(path) {
  const { formState } = useFormContext() || { formState: {} as any};
  return path?.split('.').reduce((o, k) => (o || {})[k], formState?.errors);
}

export function removeNumbers(str: string): string {
  let sanitized = str.replace(/\d+/g, '');
  sanitized = sanitized.replace(/\.{2,}/g, '.');
  if (/\.\d+$/.test(str)) {
    sanitized = sanitized.replace(/\.$/, '');
  }
  return sanitized;
}

export const formatPhoneNumber = (value: string) => {
  const cleaned = value.replace(/\D/g, '');
  if (cleaned.length <= 3) return cleaned;
  if (cleaned.length <= 6) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
  return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
};

export const formatTaxId = (value: string) => {
  const cleaned = value.replace(/\D/g, '');
  if (cleaned.length <= 2) return cleaned;
  return `${cleaned.slice(0, 2)}-${cleaned.slice(2, 9)}`;
};

export const formatSSN = (value: string) => {
  const cleaned = value.replace(/[^0-9x]/gi, '');
  if (cleaned.length <= 3) return cleaned;
  if (cleaned.length <= 5) return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
  return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 5)}-${cleaned.slice(5, 9)}`;
};

export const formatZipCode = (value: string) => {
  const cleaned = value.replace(/\D/g, '');
  if (cleaned.length <= 5) return cleaned;
  return `${cleaned.slice(0, 5)}-${cleaned.slice(5, 9)}`;
};

export const formatPercentageValue = (value: string) => {
  const cleaned = value.toString().replace(/\D/g, '');
  let percentage = parseInt(cleaned, 10);
  if (isNaN(percentage)) return "";
  if (percentage < 1) percentage = 1;
  if (percentage > 100) percentage = 100;
  return percentage.toString();
};

export const stripFormatting = (value: string): string => {
  return value.replace(/[-()\s]/g, '');
};
